<h1 style="
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
      Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-weight: 500;
    color: #105481;
    margin-bottom: 0.5rem;
    font-size: 2.5rem;
    font-weight: 500;
    line-height: 1.2;
  ">
  {{delegation.routingInfRef.infRefName}}
</h1>
<mat-tab-group color="primary" mat-align-tabs="center" (selectedTabChange)="onTabChange($event)" class="tabs">
  <mat-tab label="Detaljer" class="tabs">
    <app-edit-deleg-form #editDelFormComponent [canEdit]="canEdit"  (cancelEvent)="cancel()"
      [delegation]="delegation"></app-edit-deleg-form>
  </mat-tab>
  <mat-tab label="Ændringslog">
    <app-delegation-history (cancelEvent)="cancel()" [history]="history"></app-delegation-history>
  </mat-tab>
</mat-tab-group>
<p-confirmDialog [ngStyle]="{ backgroundColor: '$dialogHeaderBg: #ffffff;' }"
  [transitionOptions]="'400ms cubic-bezier(0.25, 0.8, 0.25, 1)'" header="Confirmation" acceptIcon="" rejectIcon="">
</p-confirmDialog>